// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__cGGOt","title":"ClientInsurance_title__3r_t_","itemText":"ClientInsurance_itemText__m6yx9"};